/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';

export default function register() {
  page('/jp/learn/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx) {
    window.location.replace(path || ctx.path);
  };
}



// WEBPACK FOOTER //
// ./src/pages/jp/learn/client.js